// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rt-main-container {
    width: 100%;
    background-color: #020617;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

/* হেডার ৬০% উইডথ এবং মাঝখানে পজিশনিং */
.rt-header-wrapper {
    width: 70%;
    margin: auto; 
    background: #0f172a;
    border-radius: 12px;
    border: 1px solid #1e293b;
    padding: 10px 20px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.5);
    z-index: 10; /* সাইডবার টগলের নিচে যাতে না যায় */
}

.rt-header-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.rt-page-title {
    color: #f8fafc;
    margin: 0;
    font-size: 1.4rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.rt-back-btn {
    background: #22c55e;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    max-width: 100px;
}

.rt-header-controls {
    display: flex;
    gap: 10px;
    align-items: center;
}

.rt-dropdown {
    background: #1e293b;
    color: #3b82f6;
    border: 1px solid #334155;
    padding: 6px;
    border-radius: 4px;
    font-weight: bold;
}

.rt-icon-btn {
    background: #1e293b;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
}

.rt-icon-btn.refresh { color: #eab308; }
.rt-icon-btn.export { color: #06b6d4; }

/* লগ লিস্ট স্টাইল */
.rt-log-display-area {
    width: 100%;
    flex: 1 1;
}

.rt-log-li {
    display: flex;
    padding: 8px 30px;
    border-bottom: 1px solid #111827;
    font-family: 'Consolas', monospace;
    font-size: 14px;
}

.rt-col-host { color: #3b82f6; min-width: 120px; font-weight: bold; }
.rt-col-time { color: #64748b; min-width: 180px; margin: 0 15px; }

/* টেক্সট ডানে সরানোর জন্য padding-left */
.rt-col-text { 
    flex: 1 1; 
    word-break: break-all; 
    padding-left: 60px; 
    color: #cbd5e1;
}

/* ডাইনামিক স্ট্যাটাস কালার */
.rt-status-online { color: #22c55e !important; font-weight: 600; }
.rt-status-offline { color: #ef4444 !important; font-weight: 600; }
.rt-status-default { color: #cbd5e1; }

.rt-loader {
    color: #64748b;
    text-align: center;
    padding: 40px;
}

.rt-load-more-container {
    text-align: center;
    padding: 40px;
}

.rt-load-more-btn {
    background: transparent;
    border: 1px solid #3b82f6;
    color: #3b82f6;
    padding: 10px 30px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    transition: 0.3s;
}

.rt-load-more-btn:hover {
    background: #3b82f6;
    color: white;
}

/* --- Mobile Responsive Styles --- */

@media (max-width: 1024px) {
    /* ট্যাবলেট বা ছোট ল্যাপটপে উইডথ ৬০% থেকে বাড়িয়ে ৮০% করা হলো */
    .olt-header-wrapper, 
    .sw-header-wrapper, 
    .rt-header-wrapper {
        width: 85%;
        margin: 15px auto;
    }
}

@media (max-width: 768px) {
    /* মোবাইলের জন্য হেডার উইডথ ৯৫% */
    .olt-header-wrapper, 
    .sw-header-wrapper, 
    .rt-header-wrapper {
        width: 95%;
        padding: 10px;
        margin: 10px auto;
    }

    .olt-header-inner, 
    .sw-header-inner, 
    .rt-header-inner {
        flex-direction: column; /* এলিমেন্টগুলো উপর নিচ হবে */
        gap: 15px;
        text-align: center;
    }

    /* হেডার টাইটেল সাইজ ছোট করা */
    .olt-page-title, 
    .sw-page-title, 
    .rt-page-title {
        font-size: 1.1rem;
        order: -1; /* টাইটেল সবার উপরে থাকবে */
    }

    /* কন্ট্রোল বাটনগুলো (Refresh, Export) ফ্লেক্স র‍্যাপ হবে */
    .olt-header-controls, 
    .sw-header-controls, 
    .rt-header-controls,
    .olt-actions-right,
    .sw-actions-right {
        justify-content: center;
        width: 100%;
    }

    /* লগ লিস্টের ফন্ট এবং প্যাডিং কমানো */
    .olt-log-li, .sw-log-li, .rt-log-li {
        padding: 10px 15px;
        flex-direction: column; /* মোবাইল স্ক্রিনে হোস্ট, টাইম এবং মেসেজ উপর নিচ হবে */
        gap: 4px;
    }

    .olt-col-host, .sw-col-host, .rt-col-host {
        min-width: unset;
        font-size: 13px;
    }

    .olt-col-time, .sw-col-time, .rt-col-time {
        min-width: unset;
        margin: 0;
        font-size: 12px;
    }

    /* লগ মেসেজের প্যাডিং মোবাইলে কমানো হলো */
    .olt-col-text, .sw-col-text, .rt-col-text {
        padding-left: 0; 
        font-size: 13px;
        margin-top: 5px;
        border-top: 1px solid #1e293b;
        padding-top: 5px;
    }

    /* ব্যাক বাটন ছোট করা */
    .olt-back-btn, .sw-back-btn, .rt-back-btn {
        width: 100%;
        padding: 10px;
    }
}

@media (max-width: 480px) {
    /* খুব ছোট ফোনের জন্য টাইটেল আরও ছোট */
    .olt-page-title, .sw-page-title, .rt-page-title {
        font-size: 1rem;
    }
    
    .olt-dropdown, .sw-dropdown, .rt-dropdown {
        flex: 1 1;
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/LogManage/RouterLogs.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,uCAAuC;AACvC;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;IACtC,WAAW,EAAE,mCAAmC;AACpD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,uBAAuB,cAAc,EAAE;AACvC,sBAAsB,cAAc,EAAE;;AAEtC,oBAAoB;AACpB;IACI,WAAW;IACX,SAAO;AACX;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gCAAgC;IAChC,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACpE,eAAe,cAAc,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAEjE,yCAAyC;AACzC;IACI,SAAO;IACP,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,6BAA6B;AAC7B,oBAAoB,yBAAyB,EAAE,gBAAgB,EAAE;AACjE,qBAAqB,yBAAyB,EAAE,gBAAgB,EAAE;AAClE,qBAAqB,cAAc,EAAE;;AAErC;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,qCAAqC;;AAErC;IACI,8DAA8D;IAC9D;;;QAGI,UAAU;QACV,iBAAiB;IACrB;AACJ;;AAEA;IACI,iCAAiC;IACjC;;;QAGI,UAAU;QACV,aAAa;QACb,iBAAiB;IACrB;;IAEA;;;QAGI,sBAAsB,EAAE,6BAA6B;QACrD,SAAS;QACT,kBAAkB;IACtB;;IAEA,8BAA8B;IAC9B;;;QAGI,iBAAiB;QACjB,SAAS,EAAE,2BAA2B;IAC1C;;IAEA,2DAA2D;IAC3D;;;;;QAKI,uBAAuB;QACvB,WAAW;IACf;;IAEA,sCAAsC;IACtC;QACI,kBAAkB;QAClB,sBAAsB,EAAE,sDAAsD;QAC9E,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,eAAe;IACnB;;IAEA,yCAAyC;IACzC;QACI,eAAe;QACf,eAAe;QACf,eAAe;QACf,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA,uBAAuB;IACvB;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA;IACI,sCAAsC;IACtC;QACI,eAAe;IACnB;;IAEA;QACI,SAAO;QACP,eAAe;IACnB;AACJ","sourcesContent":[".rt-main-container {\n    width: 100%;\n    background-color: #020617;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n/* হেডার ৬০% উইডথ এবং মাঝখানে পজিশনিং */\n.rt-header-wrapper {\n    width: 70%;\n    margin: auto; \n    background: #0f172a;\n    border-radius: 12px;\n    border: 1px solid #1e293b;\n    padding: 10px 20px;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.5);\n    z-index: 10; /* সাইডবার টগলের নিচে যাতে না যায় */\n}\n\n.rt-header-inner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.rt-page-title {\n    color: #f8fafc;\n    margin: 0;\n    font-size: 1.4rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.rt-back-btn {\n    background: #22c55e;\n    color: white;\n    border: none;\n    padding: 8px 15px;\n    border-radius: 6px;\n    font-weight: bold;\n    cursor: pointer;\n    max-width: 100px;\n}\n\n.rt-header-controls {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.rt-dropdown {\n    background: #1e293b;\n    color: #3b82f6;\n    border: 1px solid #334155;\n    padding: 6px;\n    border-radius: 4px;\n    font-weight: bold;\n}\n\n.rt-icon-btn {\n    background: #1e293b;\n    color: white;\n    border: none;\n    padding: 8px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.rt-icon-btn.refresh { color: #eab308; }\n.rt-icon-btn.export { color: #06b6d4; }\n\n/* লগ লিস্ট স্টাইল */\n.rt-log-display-area {\n    width: 100%;\n    flex: 1;\n}\n\n.rt-log-li {\n    display: flex;\n    padding: 8px 30px;\n    border-bottom: 1px solid #111827;\n    font-family: 'Consolas', monospace;\n    font-size: 14px;\n}\n\n.rt-col-host { color: #3b82f6; min-width: 120px; font-weight: bold; }\n.rt-col-time { color: #64748b; min-width: 180px; margin: 0 15px; }\n\n/* টেক্সট ডানে সরানোর জন্য padding-left */\n.rt-col-text { \n    flex: 1; \n    word-break: break-all; \n    padding-left: 60px; \n    color: #cbd5e1;\n}\n\n/* ডাইনামিক স্ট্যাটাস কালার */\n.rt-status-online { color: #22c55e !important; font-weight: 600; }\n.rt-status-offline { color: #ef4444 !important; font-weight: 600; }\n.rt-status-default { color: #cbd5e1; }\n\n.rt-loader {\n    color: #64748b;\n    text-align: center;\n    padding: 40px;\n}\n\n.rt-load-more-container {\n    text-align: center;\n    padding: 40px;\n}\n\n.rt-load-more-btn {\n    background: transparent;\n    border: 1px solid #3b82f6;\n    color: #3b82f6;\n    padding: 10px 30px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: 0.3s;\n}\n\n.rt-load-more-btn:hover {\n    background: #3b82f6;\n    color: white;\n}\n\n/* --- Mobile Responsive Styles --- */\n\n@media (max-width: 1024px) {\n    /* ট্যাবলেট বা ছোট ল্যাপটপে উইডথ ৬০% থেকে বাড়িয়ে ৮০% করা হলো */\n    .olt-header-wrapper, \n    .sw-header-wrapper, \n    .rt-header-wrapper {\n        width: 85%;\n        margin: 15px auto;\n    }\n}\n\n@media (max-width: 768px) {\n    /* মোবাইলের জন্য হেডার উইডথ ৯৫% */\n    .olt-header-wrapper, \n    .sw-header-wrapper, \n    .rt-header-wrapper {\n        width: 95%;\n        padding: 10px;\n        margin: 10px auto;\n    }\n\n    .olt-header-inner, \n    .sw-header-inner, \n    .rt-header-inner {\n        flex-direction: column; /* এলিমেন্টগুলো উপর নিচ হবে */\n        gap: 15px;\n        text-align: center;\n    }\n\n    /* হেডার টাইটেল সাইজ ছোট করা */\n    .olt-page-title, \n    .sw-page-title, \n    .rt-page-title {\n        font-size: 1.1rem;\n        order: -1; /* টাইটেল সবার উপরে থাকবে */\n    }\n\n    /* কন্ট্রোল বাটনগুলো (Refresh, Export) ফ্লেক্স র‍্যাপ হবে */\n    .olt-header-controls, \n    .sw-header-controls, \n    .rt-header-controls,\n    .olt-actions-right,\n    .sw-actions-right {\n        justify-content: center;\n        width: 100%;\n    }\n\n    /* লগ লিস্টের ফন্ট এবং প্যাডিং কমানো */\n    .olt-log-li, .sw-log-li, .rt-log-li {\n        padding: 10px 15px;\n        flex-direction: column; /* মোবাইল স্ক্রিনে হোস্ট, টাইম এবং মেসেজ উপর নিচ হবে */\n        gap: 4px;\n    }\n\n    .olt-col-host, .sw-col-host, .rt-col-host {\n        min-width: unset;\n        font-size: 13px;\n    }\n\n    .olt-col-time, .sw-col-time, .rt-col-time {\n        min-width: unset;\n        margin: 0;\n        font-size: 12px;\n    }\n\n    /* লগ মেসেজের প্যাডিং মোবাইলে কমানো হলো */\n    .olt-col-text, .sw-col-text, .rt-col-text {\n        padding-left: 0; \n        font-size: 13px;\n        margin-top: 5px;\n        border-top: 1px solid #1e293b;\n        padding-top: 5px;\n    }\n\n    /* ব্যাক বাটন ছোট করা */\n    .olt-back-btn, .sw-back-btn, .rt-back-btn {\n        width: 100%;\n        padding: 10px;\n    }\n}\n\n@media (max-width: 480px) {\n    /* খুব ছোট ফোনের জন্য টাইটেল আরও ছোট */\n    .olt-page-title, .sw-page-title, .rt-page-title {\n        font-size: 1rem;\n    }\n    \n    .olt-dropdown, .sw-dropdown, .rt-dropdown {\n        flex: 1;\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
